const diet = {
  isloading: state => state.diet.isloading
}

export default diet
